import s from './AddLinkModal.module.scss';
import { ReactComponent as CloseIcon} from "../../../../../../../../../assets/icons/close.svg"
import { useState } from 'react';
import { StyledHTMLFieldsBlock } from 'components/StyledHTMLFiledsBlock/StyledHTMLFieldsBlock';
import { useSelector } from 'react-redux';
import { PrimaryButton } from 'components/PrimaryButton/PrimaryButton';
import { SecondaryButton } from 'components/SecondaryButton/SecondaryButton';
import { useStatusContext } from 'components/StatusProvider';
import { ValidateTextFields } from 'utils/validation';
import { useTranslation } from 'react-i18next';

export const AddLinkModal = ({activeLang, currentModule, currentLesson, setActiveLang, hide, setForm}: any) => {

    // ### State
    const langs = useSelector((store: any) => store.main.langs);
    const { openStatus } = useStatusContext();
    const {t} = useTranslation()

    const [state, setStorage] = useState({
        link: undefined,
        title: langs?.reduce((acc: any, lang: any) => {
            acc[lang.key] = ""
            return acc
        }, {}),
    })

    // ### Effects

    // ### Functions

    function addLink(){
        let error
        if(!ValidateTextFields(state.title, langs)) error = t('courses.text_link_error')
        if(!state.link) error = t('courses.link_error')

        if(error){
            openStatus('error', error);
            return
        }
        setForm((prev: any) => ({
            ...prev,
            modules: prev?.modules?.map((mod: any) => {
                if(mod.id === currentModule.id){
                    return {
                        ...mod,
                        lessons: mod.lessons?.map((les: any) => {
                            if(les.id === currentLesson.id){
                                return {
                                    ...les,
                                    links: [
                                        ...les.links,
                                        {
                                            id: Number(new Date().getTime().toString().slice(-5)),
                                            ...state
                                        }
                                    ]
                                }
                            } else return les
                        })
                    }
                }else return mod
            })
        }))
        hide()
    }

    // ### Views

    return(
        <div className={s.wrapper}>
            <div className={s.modal}>
                <header className={s.header}>
                    <span className={s.title}>{t('courses.add_link')}</span>
                    <div className={s.close} onClick={hide}><CloseIcon/></div>
                </header>
                <div className={s.content}>
                    <div className={s.item}>
                        <span>{t('general.link')}</span>
                        <input 
                            type="text"
                            value={state.link}
                            onChange={(e) => setStorage((prev: any) => ({...prev, link: e.target.value}))}
                        />
                    </div>
                    <div className={s.item}>
                        <StyledHTMLFieldsBlock 
                            values={state.title}
                            changeValue={(value: any) => setStorage((prev: any) => ({...prev, title: {...prev.title, ...value}}))}
                            title={t('general.name')}
                            setActiveLang={setActiveLang}
                            activeLang={activeLang}
                            height={150}
                        />
                    </div>
                </div>
                <footer className={s.footer}>
                    <PrimaryButton 
                        text={t('general.save')}
                        type={"button"}
                        style={{width: "fit-content"}}
                        onClick={addLink}
                    />
    
                    <SecondaryButton
                        text={t('general.back')}
                        type={"button"}
                        style={{width: "fit-content"}}
                        onClick={hide}
                    />
                </footer>
            </div>
        </div>
    )
}